module.exports = __webpack_public_path__ + "img/image2.7d60089b.png";